import { ROLES } from '../constants';

// intentional no-op edit to trigger file write
export const getRole = (userManagerLevel: string,isPseudoSupervisor:boolean) => {
    if (isPseudoSupervisor===true) return 'supervisor';
    if (ROLES.Agents.includes(userManagerLevel)) return 'associate';
    else if (ROLES.Supervisor2AndAbove.includes(userManagerLevel)) return 'manager';
    else if (ROLES.Supervisor.includes(userManagerLevel)) return 'supervisor';
    else return '';
};
